// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
}

.top-space {
  margin-top: 4px;
  height: 100%;
}

.title-documents {
  text-align: left;
  font-family: var(--font);
  font-weight: 700;
  font-size: 20px;
  display: flex;
  align-items: center;
  padding-left: 14px;
  margin-bottom: 8px;
}
.title-documents > span {
  margin-left: 7px;
}
.title-documents ion-icon {
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/reusable_components/interactivity/documents/documents.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,YAAA;AACJ;;AAEA;EACI,gBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAEJ;AADI;EACI,gBAAA;AAGR;AADI;EACI,WAAA;EACA,YAAA;AAGR","sourcesContent":[":host {\n    width: 100%;\n    height: 100%;\n}\n\n.top-space {\n    margin-top: 4px;\n    height: 100%;\n}\n\n.title-documents{\n    text-align: left;\n    font-family: var(--font); font-weight: 700;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    padding-left: 14px;\n    margin-bottom: 8px;\n    > span {\n        margin-left: 7px;\n    }\n    ion-icon{\n        width: 20px;\n        height: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
